import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { Observable, from } from 'rxjs';
import { WizardComponent } from 'ng2-archwizard/dist';

// Services
import { RegistrationService } from '../../services/registration.service';
import { LocationService } from '../../services/location.service';
import { DialogService } from '../../services/dialog.service';
import { OAuthService } from '../../services/oauth.service';
import { GlobalFlagsService } from '../../services/global-flags.service';
import { CustomPageService } from '../../services/custom-page.service';

import { UserFormActions } from '../user/user-form-actions';
import { UserForm } from '../../models/UserForm';

import { DialogComponent } from '../commons/dialog/dialog.component';

import { FormBuilder, FormGroup } from '@angular/forms';

import * as moment from 'moment'; // add this 1 of 4

@Component({
  selector: 'app-wizard',
  templateUrl: './wizard.component.html',
  styleUrls: ['./wizard.component.scss', './wizard.component.medium.scss']
})

export class WizardComponentRegister implements OnInit {

  _dobValid: boolean = false;
  get dobValid() {
    return this._dobValid;
  }

  set dobValid(value: boolean) {
    this._dobValid = value;
  }

  constructor(private route: ActivatedRoute,
    private router: Router,
    private registrationService: RegistrationService,
    private locationService: LocationService,
    private fb: FormBuilder,
    private dialog: MatDialog,
    private customPageService: CustomPageService,
    private globalFlagsService: GlobalFlagsService,
    private oAuthService: OAuthService,
    private dialogService: DialogService) {

  }

  @ViewChild(WizardComponent)
  public wizard: WizardComponent;

  viewObj = {
    htmlContent: null,
    name: null
  };

  email = null;
  token = null;
  confirmPassword = null;

  userRegistered = false;

  emailRegistration = false;

  invalidAccess;

  action = UserFormActions.Register;
  userDetails: UserForm = new UserForm();

  formCreated = false;

  editUserForm: FormGroup;

  private sub;
  private res;

  public objStep1 = null;
  public objStep2 = null;

  public immunoCheck = false;
  public hospitalCheck = false;
  public disableStates = true;

  public showHospitalStep;
  public contentLoaded = false;



  states: any;
  countries: any;
  regions: any;
  diagnosticsArray: any;

  birthDate = {
    day: 0,
    month: '',
    year: 0
  };
  yearsArr = Array();
  monthsArr = moment.months();
  daysArr = Array();

  isFieldInvalid(field: any) {
    const fieldFlags = this.editUserForm.get(field);
    return (fieldFlags.invalid && (fieldFlags.dirty || fieldFlags.touched));
  }

  ngOnInit() {
    this.dontGoBack();
    this.oAuthService.logout();
    let er;
    // Show Loading
    this.globalFlagsService.displayLoad(true);
    this.sub = this.route.queryParams.subscribe(params => {
      this.email = params['email'];
      this.token = params['token'];
      er = params['er'];

	  // If it is an email registration, we have to skip date of birth validation and set the flag to true
    if (er === 'true') {
      this.dobValid = this.emailRegistration = true;
    }
    else{
      this.populateDatesArr();
    }

     });
  }

  enterImmuno(event) {
    if (this.objStep1 === this.viewObj) {
      return;
    } else if (this.objStep1) {
      this.populateViewObjects(this.objStep1);
    } else {
      // call BE
    }
  }

  enterHospital(event) {
    if (this.objStep2) {
      this.populateViewObjects(this.objStep2);
    } else {
      this.globalFlagsService.displayLoad(true);
    }
  }

  populateViewObjects(data, step = null) {
    this.viewObj = { ...this.viewObj, ...data };
  }

  populateDatesArr() {
    const firstYear = 1900;
    const actualYear = moment().year();
    for (let i = firstYear; i <= actualYear; i++) {
      this.yearsArr.push(i);
    }
    this.yearsArr = this.yearsArr.sort((a, b) => a > b ? -1 : 1);
    this.daysArr = Array(31).fill(0).map((e, i) => i + 1);
  }

  initRegisterForm() {
    this.userDetails.email = this.email;
    this.userDetails.token = this.token;
    this.formCreated = true;
  }

  onSubmitSuccess($event) {
    this.globalFlagsService.displayLoad(true);
    this.userRegistered = true;
    setTimeout(() => {
      this.oAuthService.login(this.userDetails.email, this.userDetails.secMemberships[0].password, false)
        .subscribe((loginRes) => {
          const localResources = from(this.customPageService.getLocalResources());
          localResources
            .subscribe(() => { },
            err => {
              localStorage.setItem('disableLocalResources', 'true');
            });
          // login successful
          this.globalFlagsService.displayLoad(false);
          this.globalFlagsService.setUserLogged(true);
          this.router.navigate(['/']);
        }, (err) => {
          this.globalFlagsService.displayLoad(false);
          this.router.navigate(['/']);
          throw err;
        });
      const data = { message: 'Registration has been finished successfully' };
      const dialogRef = this.dialog.open(DialogComponent, { data });
      dialogRef.afterClosed().subscribe(() => {
        window.scrollTo(0, 0);
      });
    }, 2000);
  }

  finishFunction() {
    const month = moment().month(this.birthDate.month).format('M');

    const obj = {
      'email': this.email,
      'token': this.token,
      'dateOfBirth': `${month}/${this.birthDate.day}/${this.birthDate.year}`
    };

    this.globalFlagsService.displayLoad(true);

    const confirmation = from(this.registrationService.confirm(obj));
    confirmation
      .subscribe((res: any) => {
        if (res.valid) {
          this.dobValid = true;
          setTimeout(() => {
            this.wizard.navigation.goToNextStep();
          });
        } else {
          this.dobValid = false;
          const message = 'Incorrect date of birth. Please try again.';
          this.dialogService.openErrorDialog({ message });
        }
        this.globalFlagsService.displayLoad(false);
      });
  }

  canDeactivate(): Observable<any> {
    const data = {
      message: 'Are you sure you want to cancel the registration?',
      cancelButton: true
    };

    return new Observable((observer) => {
      if (this.userRegistered || this.invalidAccess) {
        return observer.next(true);
      } else {
        const dialogRef = this.dialog.open(DialogComponent, { data });
        dialogRef.afterClosed().subscribe(result => {
          if (result) {
            observer.next(true);
          } else {
            observer.next(false);
          }
          observer.unsubscribe();
        });
      }
    });
  }

  dontGoBack() {
    if (typeof (global) === 'undefined') {
      throw new Error('window is undefined');
    }

    const _hash = '!';
    const noBackPlease = () => {
      window.location.href += '#';

      setTimeout(() => {
        window.location.href += '!';
      }, 50);
    };

    window.onhashchange = () => {
      if (window.location.hash !== _hash) {
        window.location.hash = _hash;
      }
    };

    window.onload = () => {
      noBackPlease();

      // disables backspace on page except on input fields and textarea..
      document.body.onkeydown = function (e: any) {
        const elm = e.target.nodeName.toLowerCase();
        if (e.which === 8 && (elm !== 'input' && elm !== 'textarea')) {
          e.preventDefault();
        }
        // stopping event bubbling up the DOM tree..
        e.stopPropagation();
      };
    };
  }

}
